module.exports = __webpack_public_path__ + "static/media/1POLICY18.07e8882b.jpg";